
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { GenerationType, GenerationPayloadType } from "@/common/types/generation";

export async function generationList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/generation/list${queryString}`
    );
}

export async function generationGet(
    generation_id: string
) {
    return await clientAxios.get(
        `admin/generation/${generation_id}/show`
    );
}

export async function generationAdd(
    payload: GenerationPayloadType
) {
    return await clientAxios.post(
        `admin/generation/create`,
        payload
    );
}

export async function generationPatch(
    generation_id: string,
    payload: Partial<GenerationType>
) {
    return await clientAxios.patch(
        `admin/generation/${generation_id}/patch`,
        { payload }
    );
}

export async function generationDel(
    generation_id: string,
) {
    return await clientAxios.del(
        `admin/generation/${generation_id}/delete`,
    );
}
